(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('VoceBilancioSearch', VoceBilancioSearch);

    VoceBilancioSearch.$inject = ['$resource'];

    function VoceBilancioSearch($resource) {
        var resourceUrl =  'api/_search/voce-bilancios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
